<div class="row h-100">
    <div class="col-12">
        <div class="order-placed-container h-100">
            <div class="text-center">
                <svg class="cxone-checkout-icon-completed">
                    <use href="../App_Themes/CXone/icons/order-placed.svg#order-placed"></use>
                </svg>
                <h1 class="lato-bold font-size-18 color-whaleTail cxone-checkout-message"><span cvLocalizedText
                        langSection="MarketPlace" langKey="Thank_You">Thank you!</span></h1>
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-text cxone-btn-keep-shopping" (click)="goToBrowse()">
                    <span cvLocalizedText langSection="MarketPlace" langKey="Keep_Shopping">Keep Shopping</span>
                </button>
                <button type="button" class="btn btn-secondary cxone-btn-view-orders" (click)="goToOrders()">
                    <span cvLocalizedText langSection="MarketPlace" langKey="Order_Details">Order Details</span>
                </button>
            </div>
        </div>
    </div>
</div>